import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FieldConfig } from "../../models/field.interface";
import { SubFormComponent } from '../../sub-form/sub-form.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-bulk-group',
  template: `
<div [formGroup]="group" class="hazard-description  bulk-fields">
  <p class="dyanmic-title dynamic-paragraph" [ngClass]="{'pointer-events' : !field.style.editability}">{{field.name}}<b>*</b> <img (click)="fillForm(undefined)" src="assets/rff-images/bulk.png"></p>
    <ng-container *ngFor="let data of field.value;"></ng-container>
    <ul class="status-bulk-fiels nav" *ngFor="let fields of field.value;let index = index" (click)="fillForm(index)">
      <li>{{fields.createdAt | amLocal | amDateFormat : "MMM DD, YYYY"}}</li>
      <li *ngIf="fields.status === 1">Completed</li>
      <li *ngIf="fields.status !== 1">Draft</li>
    </ul>
</div>
`,
  styles: [`.status-bulk-fiels{background: url(assets/rff-images/formchevronright.svg) no-repeat 97% 54%;background-size : 3%}`]
})
export class BulkGroupComponent implements OnInit {
  field: FieldConfig;
  group: FormGroup;
  editedIndex: number;
  constructor(
    private modalService: NgbModal
  ) { }
  ngOnInit() {
  }
  fillForm(index) {
    let modalOptions: any = {
      size: 'md',
      centered: true,
      windowClass: 'md-dialog-large',
    };
    const modalRef = this.modalService.open(
      SubFormComponent,
      modalOptions
    );
    var newTemplateJson = this.field.data[0];
    modalRef.componentInstance.template = newTemplateJson;
    modalRef.componentInstance.subFormPreview = true;
    if (this.field.value && index != undefined) {
      this.editedIndex = index;
      modalRef.componentInstance.data = this.field.value[index]['data']['data'];
    }
    modalRef.result.then((data) => {
      let status = 0;
      if (data.data && Object.keys(data.data).length === 6) {
        status = 1;
      }
      if (this.field.value && this.field.value[this.editedIndex]) {
        let finalData = this.field.value[this.editedIndex];
        finalData.data = data;
        finalData.status = status;
        finalData.updatedAt = new Date();
        this.field.value[this.editedIndex] = finalData;
        this.editedIndex = undefined;
      } else {
        const finalData = {
          data: data,
          createdAt: new Date(),
          updatedAt: new Date(),
          status: status
        }
        if (!this.field.value) {
          this.field.value = [];
        }
        this.field.value.push(finalData);
      }
    });
  }
}


// WEBPACK FOOTER //
// ./src/app/rFF/fields/bulk-group/bulk-group.component.ts